module.exports = __webpack_public_path__ + "img/published-1-min.3497a6f5.png";